import { render } from "./Details.vue?vue&type=template&id=91f361d6&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=91f361d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-91f361d6"

export default script